import { CashTokenRequest } from "@kushki/js/lib/types/cash_token_request";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input as InputField } from "components/Input/InputComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import {
  getCashToken,
  setDirty,
  updateCashDocumentType,
  updateInput,
} from "containers/Cash/store/ActionCreators";
import { get } from "lodash";
import * as React from "react";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Input, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { CountryEnum } from "root/shared/CountryEnum";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import {
  brasilDocumentTypes,
  chileDocumentTypes,
  colombiaDocumentTypes,
  costaRicaDocumentTypes,
  ecuadorDocumentTypes,
  elSalvadorDocumentTypes,
  guatemalaDocumentTypes,
  hondurasDocumentTypes,
  mexicoDocumentTypes,
  nicaraguaDocumentTypes,
  panamaDocumentTypes,
  peruDocumentTypes,
} from "root/shared/DocumentTypes";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getCashImage,
} from "root/shared/Utility";
import { CajitaStore, IInputProps } from "root/store/CajitaStore";
import { ICashFormProps } from "types/cajita_store";
import { ICashActionCreator } from "types/cash_action_creator";
import { IdDocumentType } from "types/document_type";
import { ITransferAmount } from "types/transfer_amount";
import "./assets/css/styles.css";

/**
 * Cash StateFull Component
 */
class Cash extends React.Component<
  ICashFormProps & LocalizeContextProps,
  { documentTypesArray: IdDocumentType[] }
> {
  constructor(props: ICashFormProps & LocalizeContextProps) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this.state = { documentTypesArray: [] };
    this._inputHandler = this._inputHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
  }

  public componentDidMount(): void {
    const documentTypesArray: IdDocumentType[] = this._getDocumentTypesArray();

    this.setState({
      documentTypesArray,
    });

    if (!this._isMXNCurrency())
      this.props.updateCashDocumentType(documentTypesArray[0].mnemonic);
  }

  public componentDidUpdate(): void {
    // istanbul ignore else
    if (this.props.token !== undefined && this.props.token !== "")
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.CASH,
      });

    return;
  }

  public render(): React.ReactNode {
    return !this.props.isCashAvailable ? (
      <Container>
        <Row className={"text-center"}>
          <Col>
            <h4>
              <Translate id="notAvailableCash" />
            </h4>
          </Col>
        </Row>
        <div className={"pseImage"} />
        <div className={"poweredBy"} />
      </Container>
    ) : (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />

        <div className="cash-container">
          <div className="section">
            <Row>
              <Col xs="12 font-size-14">
                <Translate id="cashHelperMessage" />
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col xs="12">
                <InputField
                  {...this.props.nameInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col xs="12" sm="12" className="mt-1 mt-sm-0">
                <InputField
                  {...this.props.lastNameInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section" hidden={this._isMXNCurrency()}>
            <Row>
              <Col xs={4} sm={4} md={2} lg={2} xl={2}>
                {this._renderDocumentTypes()}
              </Col>
              <Col
                xs={8}
                sm={8}
                md={10}
                lg={10}
                xl={10}
                style={{ paddingLeft: 0 }}
              >
                <InputField
                  {...this.props.identificationInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col
                xs="12"
                sm="12"
                lg="12"
                xl="12"
                className="email-cash-out-input"
              >
                <InputField
                  {...this.props.email}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <div className="section" hidden={this._isMXNCurrency()}>
            <Row>
              <Col>
                <InputField
                  {...this.props.description}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>

          <PayButton
            isValid={this.props.isValid}
            totalAmount={this.props.cashAmount}
            isSubscription={false}
            isPayin={true}
            currency={this.props.currency}
            disable={this.props.disablePayButton}
          />
        </div>

        <Footer
          pciClass={getCashImage(this.props.currency)}
          showLanguajeToggle={this.props.isLanguageToggleAvailable}
        />
      </form>
    );
  }

  private _isMXNCurrency(): boolean {
    return this.props.currency === CurrencyEnum.MXN;
  }

  private _getDocumentTypesArray(): IdDocumentType[] {
    let documentTypesArray: IdDocumentType[] = [];

    switch (this.props.currency) {
      case CurrencyEnum.MXN:
        documentTypesArray = mexicoDocumentTypes;
        break;
      case CurrencyEnum.PEN:
        documentTypesArray = peruDocumentTypes;
        break;
      case CurrencyEnum.COP:
        documentTypesArray = colombiaDocumentTypes;
        break;
      case CurrencyEnum.BRL:
        documentTypesArray = brasilDocumentTypes;
        break;
      case CurrencyEnum.CLP:
        documentTypesArray = chileDocumentTypes;
        break;
      case CurrencyEnum.CRC:
        documentTypesArray = costaRicaDocumentTypes;
        break;
      case CurrencyEnum.GTQ:
        documentTypesArray = guatemalaDocumentTypes;
        break;
      case CurrencyEnum.PAB:
        documentTypesArray = panamaDocumentTypes;
        break;
      case CurrencyEnum.HNL:
        documentTypesArray = hondurasDocumentTypes;
        break;
      case CurrencyEnum.NIO:
        documentTypesArray = nicaraguaDocumentTypes;
        break;
      case CurrencyEnum.USD:
        if (this.props.country === (CountryEnum.EC as string)) {
          documentTypesArray = ecuadorDocumentTypes;
          break;
        }
        if (this.props.country === (CountryEnum.ES as string)) {
          documentTypesArray = elSalvadorDocumentTypes;
          break;
        }
        if (this.props.country === (CountryEnum.PA as string)) {
          documentTypesArray = panamaDocumentTypes;
          break;
        }
        break;
      default:
        documentTypesArray = ecuadorDocumentTypes;
        break;
    }

    return documentTypesArray;
  }

  private _renderDocumentTypes(): JSX.Element {
    return (
      <Input
        type="select"
        name="select"
        id={"selectDocumentType"}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          this.props.updateCashDocumentType(e.target.value);
        }}
        required={true}
      >
        {this.state.documentTypesArray.map(
          (item: IdDocumentType, key: number) => (
            <option key={key}>{item.mnemonic}</option>
          )
        )}
      </Input>
    );
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    // @ts-ignore
    const cashTokenRequest: CashTokenRequest = {
      currency: this.props.currency,
      documentType: this.props.documentType,
      identification: this._isMXNCurrency()
        ? undefined
        : this.props.identificationInput.value,
      name: this.props.nameInput.value,
      lastName: this.props.lastNameInput.value,
      totalAmount: this.props.cashAmount,
      email: get(this.props.email, "value", ""),
      description: get(this.props.description, "value", ""),
    };

    this.props.requestToken(cashTokenRequest);
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    new_input.valid = checkValidity(newValue, new_input.rules);
    new_input.value = newValue;

    this.props.onChangeInput(new_input);
  }
}

const mapStateToProps: (state: CajitaStore) => ICashFormProps = (
  state: CajitaStore
): ICashFormProps => ({
  ...state.cash,
  cashAmount:
    typeof state.config.amount === "object"
      ? calculateTotalAmount(state.config.amount as ITransferAmount)
      : state.config.amount,
  isLanguageToggleAvailable: true,
  currency: state.config.currency,
  country: state.config.country,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, ICashActionCreator>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): ICashActionCreator =>
    dispatch(setDirty(payload)),
  requestToken: (payload: CashTokenRequest): void =>
    dispatch(getCashToken(payload)),
  updateCashDocumentType: (payload: string): void =>
    dispatch(updateCashDocumentType(payload)),
});

const CashComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<ICashFormProps & LocalizeContextProps>(Cash));

export { CashComponent };



// WEBPACK FOOTER //
// ./src/containers/Cash/CashComponent.tsx